export const collections = [
  {
    id: 'uncut-hits',
    title: '无修精选合集',
    subtitle: '按地区与版本逐一核对',
    count: 36,
    tags: ['无修资源', '画质优先', '合集整理'],
    desc: '把热门口碑番的未删减版本整理成一张清单，标注了版本差异与镜头说明，方便你在开播前先确认想看的到底是哪一版。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20inspired%20stylized%20illustration%20of%20a%20collection%20of%20glowing%20film%20reels%20and%20posters%20floating%20in%20a%20warm%20amber%20studio%20space%2C%20digital%20art%2C%20clean%20composition%2C%20rich%20warm%20tones%2C%20no%20text&width=800&height=600&seq=yaojing-coll-uncut-01&orientation=landscape',
  },
  {
    id: 'late-night',
    title: '深夜档与里番合集',
    subtitle: '按剧情 / 氛围分类索引',
    count: 24,
    tags: ['里番合集', '深夜档', '分类索引'],
    desc: '面向成年观众的深夜档作品索引，按剧情走向与氛围标签分类，仅提供条目信息与观看顺序建议，方便按主题规划补番清单。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20inspired%20stylized%20illustration%20of%20a%20moody%20night%20city%20rooftop%20with%20neon%20signs%20reflected%20on%20wet%20pavement%2C%20deep%20teal%20and%20warm%20amber%20lights%2C%20atmospheric%20digital%20art%2C%20no%20text&width=800&height=600&seq=yaojing-coll-night-02&orientation=landscape',
  },
  {
    id: 'hidden-gems',
    title: '冷门佳作补番清单',
    subtitle: '高分但少人问津',
    count: 18,
    tags: ['补番', '冷门', '口碑向'],
    desc: '评分不低却常被忽略的作品合集，每一部都附上一句“值得看的理由”，适合从热门追更之余换个口味慢慢补。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20inspired%20stylized%20illustration%20of%20a%20hidden%20bookshelf%20nook%20with%20warm%20string%20lights%20and%20stacked%20books%2C%20cozy%20soft%20amber%20palette%2C%20digital%20art%2C%20inviting%20mood%2C%20no%20text&width=800&height=600&seq=yaojing-coll-gems-03&orientation=landscape',
  },
];